import type { FinalResults } from "../types/finalResults";

/**
 * One-sentence plain-language Reveal payoff (PRD §3.3).
 * Returns null when there is nothing to summarize.
 */
export function plainLanguageRevealSummary(results: FinalResults): string | null {
	if (results.voteCount === 0 || results.winners.length === 0) return null;
	const sorted = [...results.optionTallies].sort((a, b) => b.normalized - a.normalized);
	const winners = sorted.filter((t) => results.winners.includes(t.id));
	if (winners.length === 0) return null;

	if (winners.length === 1) {
		const winner = winners[0]!;
		const runner = sorted.find((t) => t.id !== winner.id);
		if (!runner) return `${winner.content} wins.`;
		const gap = winner.normalized - runner.normalized;
		if (gap >= 15) return `${winner.content} wins, clearly ahead of the rest.`;
		if (gap >= 5) return `${winner.content} wins ahead of ${runner.content}.`;
		return `${winner.content} edges out ${runner.content}.`;
	}

	const names = winners.map((w) => w.content);
	if (names.length === 2) return `${names[0]} and ${names[1]} tie for the top.`;
	return `${names.slice(0, -1).join(", ")}, and ${names[names.length - 1]} tie for the top.`;
}
